<template>
	<div class="row">
        <b-modal ok-only @ok="$bvModal.hide('feedbackModal')" v-model="feedbackModalMessage" type="warn" title="Feedback sent">
            <p>Thank your for your feedback. Someone from our team will look into the matter ASAP.</p>
        </b-modal>
        <div class="col-md-12">
            <b-form-group label="Feedback type">
                <b-form-radio v-model="feedbackType" name="feedbackType" value="feature request">Requesting a feature</b-form-radio>
                <b-form-radio v-model="feedbackType" name="feedbackType" value="bug report">I found a bug</b-form-radio>
            </b-form-group>
        </div>
		<div class="col-md-12">
			<div class="form-group">
				<label>Message</label>
                <ckeditor
                editorUrl="/js/ckeditor/ckeditor.js"
                v-model="feedbackMessage"
                :config="editorConfig"
                />
			</div>
		</div>
		<div class="col-md-12">
			<div class="form-group">
				<button class="btn btn-primary" type="button" @click="sendFeedback" data-dismiss="modal">Send</button>
			</div>
		</div>
	</div>

</template>

<script>
import Format from "../../utility/Format";

export default {
	data() {
		return {
            feedbackModalMessage: false,
            feedbackType: '',
            feedbackMessage: '',
            editorConfig: {
                toolbar:  [
                    { name: 'document', groups: [ 'mode' ], items: [ 'Source' ] },
                    { name: 'clipboard', groups: [ 'undo' ], items: [ 'Undo', 'Redo' ] },                                        
                    { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ], items: [ 'Bold', 'Italic', 'Underline', '-', 'RemoveFormat' ] },
                    { name: 'paragraph', groups: [ 'list', 'blocks', 'align' ], items: [ 'NumberedList', 'BulletedList' ] },
                    { name: 'links', items: [ 'Link', 'Unlink' ] },
                    { name: 'insert', items: [ 'Image' ] },
                    { name: 'colors', items: [ 'TextColor', 'BGColor' ] },
                    { name: 'tools', items: [ 'Maximize' ] }
                  ]
            }
		};
    },
    components: {
        Format
    },
	mounted() {
        $('#feedbackModal .modal-content').removeAttr('tabindex')
	},
	methods: {
		sendFeedback() {
            let feedbackType = this.feedbackType,
                feedbackMessage = this.feedbackMessage,
                currentUserId = localStorage.getItem('userId')
			this.$store.dispatch("sendFeedback", {
				feedbackType,
                feedbackMessage,
                currentUserId
            });
            this.feedbackType = ''
            this.feedbackMessage = ''
            // this.$bvModal.hide("feedbackModal");
            this.feedbackModalMessage = true
		}
	}
};
</script>

<style>
</style>